import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/landing';
export function TestimonialsSection() {
  return <section aria-label="Testimonios" className="bg-stone-100" data-id="element-180" data-mp="20qxfzjqp90xg">
      <div className="mx-auto max-w-6xl bg-white px-5 py-20 lg:py-24" data-id="element-181" data-mp="1n0tyf62rlvec">
        <ul className="grid gap-6 lg:grid-cols-3" data-id="element-182" data-mp="1r1m79y7q5ya3">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex flex-col rounded-2xl bg-stone-50 p-8" data-id="element-183" data-mp="1qz9h4xrtchly">
              <div className="flex gap-1" role="img" aria-label="5 de 5 estrellas" data-id="element-184" data-mp="1d3xocvx7x17o">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-brand text-brand" aria-hidden="true" data-id="element-185" data-mp="1427y3tf2o8bh" data-mpi={index} />)}
              </div>
              <blockquote className="mt-5 font-serif text-lg leading-relaxed text-stone-900" data-id="element-186" data-mp="1839w66x96ebv">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-auto pt-6" data-id="element-187" data-mp="32haveswpt3ch">
                <p className="text-sm font-semibold text-stone-900" data-id="element-188" data-mp="32fzsevb3fzmf">{testimonial.name}</p>
                {testimonial.note ? <p className="mt-1 text-xs italic text-stone-500" data-id="element-189" data-mp="2uzhq36wuksb7">{testimonial.note}</p> : null}
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}